<template>
  <el-dialog
    title="渠道下单"
    :visible.sync="dialogVisible"
    width="40%"
    class="qdApplyOrderDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="qdApplyOrderForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="下单金额" prop="qdOrderAmount">
            <el-input-number v-model="formData.qdOrderAmount" :precision="2" :min="0" :controls="false" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        rules: {
          qdOrderAmount: [
            { required: true, message: '请输入下单金额', trigger: 'blur' }
          ]
        },
        dialogVisible: false,
        formData: {}
      };
    },
    props: {
      qdApplyOrderShow: {
        type: Boolean,
        default: false
      },
      rowData: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    watch: {
      qdApplyOrderShow (val) {
        if (!val) {
          this.formData = {};
        }
        this.$nextTick(() => {
          this.$refs.qdApplyOrderForm.clearValidate();
        });
        this.dialogVisible = val;
      }
    },
    methods: {
      submitHandlen () {
        this.$refs['qdApplyOrderForm'].validate((valid) => {
          if (valid) {
            let params = {
              leadId: this.rowData.leadId,
              qdOrderAmount: this.formData.qdOrderAmount
            };
            this.$emit('submitHandle', params);
          }
        });
      },
      dialogCloseHandle () {
        this.$emit('dialogCloseHandle');
      }
    }
  };
</script>

<style lang="scss" scoped>
 .qdApplyOrderDialog{
   ::v-deep.el-dialog{
     margin-top: 20vh!important;
     .el-dialog__body{
       min-height: 150px;
       .el-input-number input{
         text-align: left;
       }
     }
    }
 }
</style>
